/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Typography, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const column1 = [
  { field: 'SKU', headerName: 'SKU', width: 150, headerAlign: 'left', align: 'left' },
  { field: 'QtyReceived_FromReturns', headerName: 'Received Returns', width: 130, headerAlign: 'left', align: 'left' },
  { field: 'QtyScrapped_FromReceipt', headerName: 'Scrapped Receipt', width: 130, headerAlign: 'left', align: 'left' },
  { field: 'PutawayQty', headerName: 'Putaway Quantity', width: 130, headerAlign: 'left', align: 'left' },
  { field: 'QtyPassed_FromCertified', headerName: 'Passed Certified', width: 130, headerAlign: 'left', align: 'left' },
  { field: 'QtyScrapped_FromCertified', headerName: 'Scrapped Certified', width: 130, headerAlign: 'left', align: 'left' },
];
const column2 = [
  { field: 'ItemNumber', headerName: 'Part Number', width: 350, headerAlign: 'left', align: 'left' },
  { field: 'QtyConsumed', headerName: 'Quantity Consumed', width: 350, headerAlign: 'left', align: 'left' },
];

const Dashboard = () => {
  const strt = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 8));
  const end = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(end);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        DashboardTable1();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(end); // for compulsory dates
    }
  }, [startDate, endDate]);

  const DashboardTable1 = async () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID')) === null || undefined ? null : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Dashboard View',
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    await fetch(`${variables.BASE_URL}DashboardView`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false && JSON.parse(result)?.IsAuthorize !== false) {
          // console.log(JSON.parse(result).DailyProductReturnsActivity[0]);
          setTableData1(JSON.parse(result).DashboardView);
          setTableData2(JSON.parse(result).MaterialConsumption);
        } if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData1([]);
          setTableData2([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={DashboardTable1}
          />
        </div>
        {loading ? (
          <LoadingOverlay />
        ) : (
          <div>
            {themeSettings}
            <div className="container-fluid">
              <div className="row" id="table_container">
                <Paper className="dashboardtable">
                  <Typography variant="h6" sx={{ marginTop: '10px' }}>Returns & Certified</Typography>
                  <Box className="dashboardtableBox">
                    <CustomDataGrid
                      name="Scrap List"
                      tableData={tableData1}
                      column={column1}
                    />
                  </Box>
                </Paper>
                <Paper className="dashboardtable">
                  <Typography variant="h6" sx={{ marginTop: '10px' }}>Material Consumption</Typography>
                  <Box className="dashboardtableBox">
                    <CustomDataGrid
                      name="Material Consumption"
                      tableData={tableData2}
                      column={column2}
                    />
                  </Box>
                </Paper>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
